import React, { useState } from 'react'
import { Input, Button, message, Alert } from 'antd'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { backend } from '../../api'

export default function DataImport() {
  const [filepath, setFilepath] = useState('')
  const [loading, setLoading] = useState(false)

  const handleRestore = async () => {
    if (!filepath.trim()) {
      message.warning('请输入备份文件路径')
      return
    }
    setLoading(true)
    try {
      const res = await backend.restoreBackup(filepath.trim())
      if (res.success) {
        message.success('数据恢复成功')
      } else {
        message.error(res.message || '数据恢复失败')
      }
    } catch (err) {
      message.error('恢复请求失败: ' + (err.message || '未知错误'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <Alert
        message="警告"
        description="选择备份文件进行数据恢复，此操作将覆盖当前数据"
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="请输入备份文件路径"
          value={filepath}
          onChange={e => setFilepath(e.target.value)}
          style={{ maxWidth: 500 }}
        />
      </div>
      <Button
        type="primary"
        icon={<CloudDownloadOutlined />}
        loading={loading}
        onClick={handleRestore}
      >
        开始恢复
      </Button>
    </div>
  )
}
